import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { Project } from 'src/app/model/project/project';
import * as moment from 'moment-timezone';

export class ClientCornerMapRequestHelper {
  private constructor() {}

  static processProjects(projects: Project[]): void {
    if (!CollectionHelper.isPopulated(projects)) {
      return;
    }
    projects.forEach(p => {
      if (CollectionHelper.isPopulated(p.subProjects)) {
        p.subProjects.forEach(sp => {
          // convert from string to moment
          sp.currentCreatedAt =
            sp.currentCreatedAt == null
              ? null
              : moment(sp.currentCreatedAt)
                  .tz('Europe/Brussels')
                  .toDate();
        });
      }
    });
  }
}
